import type { RoofEdgeType } from "@logic/lib/design"
import { ROOF_EDGE_TYPES } from "@logic/lib/design"
import { atom } from "recoil"

export const EDGE_DESIGNATOR_HOTKEYS: Readonly<
  Record<RoofEdgeType, `${number}`>
> = ROOF_EDGE_TYPES.reduce(
  (acc, type, idx) => ({
    ...acc,
    [type]: `${idx + 1}`,
  }),
  {} as Record<RoofEdgeType, `${number}`>,
)

export const edgeDesignationState = atom<RoofEdgeType>({
  key: `edgeDesignation`,
  default: `eave`,
})
